import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'material-ui';
import ClassNames from 'classnames';

const NextStep = ({ className, label, nextStep, step, onClick, color, fullWidth }) => (
  <Button
    className={ClassNames(className, { disabled: !step || !step.enabled })}
    raised
    disabled={!step || !step.enabled}
    onClick={() => onClick(step.id.toLowerCase())}
    fullWidth={fullWidth}
    style={{ color: color }}
  >
    <div className='next-label'>
      {label ? <div className={`${className}-main-label`}>{label}</div> : null}
      {nextStep ? <div className={`${className}-title-label`}>{nextStep}</div> : null}
    </div>
  </Button>
);

NextStep.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  nextStep: PropTypes.string,
  fullWidth: PropTypes.bool,
  color: PropTypes.string,
  step: PropTypes.object,
  onClick: PropTypes.func,
};

export default NextStep;



// WEBPACK FOOTER //
// ./src/components/navigation/NextStep.js